module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-image/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Pequeñín","short_name":"Pequeñín","start_url":"/","background_color":"#562E91","theme_color":"#562E91","display":"standalone","icon":"src/shared/assets/images/logo/pequenin-logo-pwa.png","include_favicon":false,"legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","cacheDigest":"1bc833f56dae0ad67df6f45297ffd581"},
    },{
      plugin: require('../node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-canonical-urls/gatsby-browser.js'),
      options: {"plugins":[],"siteUrl":"https://www.pequenin.com.co"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
